class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    // Get recently viewed products
    const query = this.getProducts();
    if (!query?.length) {
      // there is no recently viewed products, add this one then return.
      // this.addProduct();
      return;
    }

    const { searchurl, sectionid } = this.dataset;

    const response = await fetch(
      `${searchurl}?section_id=${sectionid}&type=product&q=${query}`
    );
    const html = await response.text();
    let tempEl = document.createElement("div");
    tempEl.innerHTML = html;
    this.innerHTML = tempEl.querySelector("recently-viewed-products").innerHTML;
    document.querySelector(".recent-products-wrapper").style.display = "block";

    /*const productCards = this.querySelectorAll(".product-card-wrapper");
    productCards.forEach((productCard) => {
      const trustpilotWidget = productCard.querySelector(".trustpilot-widget");

      window.Trustpilot.loadFromElement(trustpilotWidget);
    });*/

    // Add this product to the recently viewed products
    // this.addProduct();
  }

  getProducts() {
    let items = JSON.parse(
      localStorage.getItem("recentlyViewedProducts") || "[]"
    );

    if (items.includes(this.dataset.currentproduct)) {
      items.splice(items.indexOf(this.dataset.currentproduct), 1);
    }

    return items
      .map((item) => {
        return "id:" + item;
      })
      .join(" OR ");
  }

  addProduct() {
    let items = JSON.parse(
      localStorage.getItem("recentlyViewedProducts") || "[]"
    );

    if (items.includes(this.dataset.currentproduct)) {
      items.splice(items.indexOf(this.dataset.currentproduct), 1);
    }

    items.unshift(this.dataset.currentproduct);

    localStorage.setItem("recentlyViewedProducts", JSON.stringify(items));
  }
}

customElements.define("recently-viewed-products", RecentlyViewedProducts);
